module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "ts-toast-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "ts-toast",
    class: _vm.customClass,
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [(!_vm.iconClass) ? _c('img', {
    attrs: {
      "src": "ts-toast--img",
      "src": _vm.typeImg
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-toast--group",
    class: {
      'is-with-icon': _vm.iconClass
    }
  }, [_c('p', [(_vm.iconClass) ? _c('i', {
    staticClass: "ts-toast--icon",
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.message) + "\r\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f083d7fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/toast/toast.vue
// module id = 863
// module chunks = 39